export default Object.freeze({
  COMPANY: 'Vazil',
  QPC: false
})
